module.exports = __webpack_public_path__ + "components/home-header/static/header-3--large-f6d774b14cbe74f9195e0b15e77ad3a1.jpg";